import axios from "axios";
const BASE_URL = "https://api.laxmaninterior.in";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
});
